import API from '../utils/api'

const searchApiBaseUrl = '/api/relatedcontent';
const contentUrl = searchApiBaseUrl + '/loadmore/';
const iconApiUrl = searchApiBaseUrl + '/icon/';

export function findRelatedContent(params) {
  return API.get(contentUrl, {
    params: params
  }).then(response => {
    return response
  })
}
export function findPagePurposeIcon(params) {
  return API.get(iconApiUrl, {
    params: params
  }).then(response => {
    return response
  })
}